<template>
  <div>
    <a-row class="center-content">
      <a-col :span="16" style="padding-right: 5px">
        <vxe-toolbar>
          <template #buttons>
            <vxe-button @click="exportDataEvent"
              ><a-icon type="cloud-download" /> Download</vxe-button
            >
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          row-id="id"
          size="small"
          :row-config="{ height: 35 }"
          ref="xTable"
          :data="tableData_detable"
          :loading="loading"
          align="center"
          header-align="center"
        >
          <vxe-column
            field="genesymbol"
            title="Gene name"
            width="150px"
            type="html"
          >
            <template #default="{ row }">
              <div style="text-align: center; font-weight: bolder; color: blue">
                <span
                  @click="goQuickGene(row.genesymbol)"
                  onmouseover="this.style.cursor='pointer'"
                >
                  {{ row.genesymbol }}
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column
            field="ensemble"
            title="Ensembl ID"
            type="html"
            show-overflow
          ></vxe-column>
          <vxe-column
            field="localization"
            title="Subcellular localizations"
            :titlePrefix="{
              icon: 'vxe-icon-question-circle-fill',
              useHTML: true,
              message:
                'Main subcellular location of proteins based on immunofluorescently stained cells from The Human Protein Atlas',
            }"
            type="html"
          ></vxe-column>
          <!-- <vxe-column field="clusters" title="Perturbation Cluster ID" type="html">
        <template #default="{ row }">
          <div v-if="row.clusters !== ''" style="text-align: center">
            <div
              v-for="(index, element) in row.clusters.split(',')"
              :key="index"
              :value="element"
            >
              <a-tag
                color="#4572a7"
                style="margin-bottom: 2px"
                @click="goTOpc(index)"
              >
                {{ index }}</a-tag
              >
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column field="datasetid" title="Dataset ID" type="html">
        <template #default="{ row }">
          <div style="text-align: center">
            <div
              v-for="(index, element) in row.datasetid.split(',')"
              :key="index"
              :value="element"
            >
              <a
                @click="gogeneDataset(index, row.genesymbol)"
                style="color: blue"
              >
                {{ index }}</a
              >
            </div>
          </div>
        </template>
      </vxe-column> -->
          <vxe-column field="genetype" title="Gene types" type="html">
            <template #default="{ row }">
              <div style="text-align: center" v-if="row.genetype != ''">
                <div
                  v-for="(index, element) in row.genetype.split(',')"
                  :key="index"
                  :value="element"
                >
                  <a-tag
                    v-if="index == 'RBP'"
                    color="pink"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'TF'"
                    color="red"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'Metabolism'"
                    color="orange"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'Essential'"
                    color="green"
                    style="margin-bottom: 2px"
                  >
                    Essential gene
                  </a-tag>
                  <!-- <a-tag
                    v-if="index == 'E3'"
                    color="cyan"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag> -->
                </div>
              </div>
            </template>
          </vxe-column>
          <vxe-column
            field="newGene"
            title="New within this cluster ?"
            type="html"
            :titlePrefix="{
              icon: 'vxe-icon-question-circle-fill',
              useHTML: true,
              message:
                'Genes lacking annotations to any pathway or complex on this page are designated as \'Yes\'',
            }"
          >
            <template #default="{ row }">
              <a-tag v-if="row.newGene === 'Yes'" color="#f50"> Yes </a-tag>
            </template>
          </vxe-column>
          <template #empty>
            <span style="color: grey"></span>
          </template>
        </vxe-table>

        <vxe-pager
          background
          size="small"
          :loading="loading_detable"
          :current-page="tablePage_detable.currentPage"
          :page-size="tablePage_detable.pageSize"
          :total="tablePage_detable.totalResult"
          :page-sizes="[10, 20, 50, 100]"
          :layouts="[
            'PrevPage',
            'JumpNumber',
            'NextPage',
            // 'FullJump',
            'Sizes',
            'Total',
          ]"
          @page-change="handlePageChange_table"
        >
        </vxe-pager
      ></a-col>
      <a-col :span="8" style="padding-left: 5px; text-align: center">
        <a-card style="width: 100%">
          <object :data="this.pcplot" width="100%" height="450px"></object>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  // components: { downloadexcel },
  props: ["choosepathway"],
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      //加载
      loading: true,
      pcplot:
        "http://research.gzsys.org.cn/perturbdb/data/clusters/result_plot/" +
        this.$route.query.pcID +
        ".pdf#view=FitH",
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/clusters/pcDetailsTable.php",
        {
          params: {
            clusterID: this.$route.query.pcID,
          },
        }
      )
      .then((response) => {
        var jiangxu = response.data
          .filter((item) => item.newGene) // 过滤掉 num 为 undefined 或 falsy 的元素
          .sort((a, b) => b.newGene.length - a.newGene.length); // 按照 num 属性降序排序
        this.getdata_detable = jiangxu;
        this.findList_detable(this.getdata_detable);
        this.tablePage_detable.currentPage = 1; //必须重置到第一页
        this.loading = false;
      });
  },
  methods: {
    goDataset(value1, value2) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { gene: value2, datasetId: value1 },
      });
      window.open(routeData.href, "_blank");
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "All_" + this.$route.query.pcID + "_members",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related_perturbed_gene",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goQuickGene(value) {
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
      this.value = "";
    },
    goQuickSearch(value) {
      let href = this.webiste + "/#/quickSearch?gene=" + value;
      window.open(href, "_blank");
    },
    gogeneDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    goTOpc(value) {
      let href = this.webiste + "/#/pcDetails?pcID=" + value;
      window.open(href, "_blank");
    },
    goDatasetBulk(value, value2) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genesymbol", "ensemble", "genetype", "clusters"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* 保证父元素有高度，这样垂直居中才有效 */
}
</style>
